import { render, staticRenderFns } from "./InputPPM.vue?vue&type=template&id=0231ba1a&scoped=true&"
import script from "./InputPPM.vue?vue&type=script&lang=js&"
export * from "./InputPPM.vue?vue&type=script&lang=js&"
import style0 from "./InputPPM.vue?vue&type=style&index=0&id=0231ba1a&prod&lang=css&"
import style1 from "./InputPPM.scss?vue&type=style&index=1&id=0231ba1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0231ba1a",
  null
  
)

export default component.exports